import { createApp } from 'vue'
import i18n from "../i18n";
import { createPinia } from 'pinia'
import ModalCRUDForm from "@/xkit/apps/ModalCRUDForm.vue";
import {useModalStore} from "@/xkit/stores/store-modal.js";
import {useDataTableStore} from "@/xkit/stores/store-datatable.js";
import Dropdown from "@/xkit/apps/Dropdown.vue";
import Datatable from "@/xkit/apps/DataTable.vue";
import init_gmaps_ac from "./apps/mains/google-map-ac.js";

let $ = jQuery

const pinia = createPinia()

if ( ! window.xkit ) {
	window.xkit = {}
}

$('.xkit-form-modal').not('.initialized').each(function() {
	$(this).addClass('initialized')

	const app = createApp(ModalCRUDForm, { state: JSON.parse( this.dataset.state ), wrapper_id: this.id } )
	app.config.devtools = true;

	app.use(pinia)
	app.use(i18n)
	app.mount(this)

	setTimeout(function(){
		xkit.modals = get_store_modal()
	}, 0)

})

let storeModal = null
let storeDataTable = null

function get_store_modal() {
	if ( ! storeModal ) {
		storeModal = useModalStore()
	}
	return storeModal
}
function get_datatable_modal() {
	if ( ! storeDataTable ) {
		storeDataTable = useDataTableStore()
	}
	return storeDataTable
}


window.init_xkit_modals = function( $elems ) {
	if ( ! $elems ) {
		$elems = $('[data-xkit-open-modal]')
	}
	$elems.filter(':not(.initialized)').on('click', function(e) {
		$(this).addClass('initialized')
		let store = get_store_modal()
		e.preventDefault()
		const modal_id = $(this).data('xkit-open-modal')

		let state = {};
		try {
			state = JSON.parse( this.dataset.state )
		} catch ( e ) {
			state.id = 0
		}
		store.open_modal(modal_id, state)
	})
}
init_xkit_modals()

window.init_xkit_selects = function( $elements ) {

	if ( ! $elements ) {
		$elements = $('.xkit-select')
	}

	$elements.not('.initialized').each(function() {
		$(this).addClass('initialized')
		$(this).hide()
		$(this).after( '<div id="xkit-select-' + this.id + '"></div>' )
		const app = createApp(Dropdown, { state: Object.assign( {}, this.dataset, { multiple: this.multiple } ), select_id: this.id } )
		app.config.devtools = true;

		// app.use(pinia)
		// app.use(i18n)
		app.mount('#xkit-select-' + this.id)
	})
}

$('.xkit-datatable').not('.initialized').each(function() {
	$(this).addClass('initialized')

	const app = createApp(Datatable, { state: JSON.parse( this.dataset.state ), wrapper_id: this.id } )
	app.config.devtools = true;

	app.use(pinia)
	app.use(i18n)
	app.mount(this)

	setTimeout(function(){
		xkit.datatables = get_datatable_modal()
	}, 0)

})

init_gmaps_ac()